import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useAuth } from './useAuth'

/**
 * Protegge le rotte dell'applicazione.
 *
 * Comodità lato client, non sicurezza: come `ModuleGuard` per i moduli
 * spenti, un backend vero deve rifiutare comunque le richieste non
 * autenticate. Ricorda da dove si veniva, così dopo il login si torna lì.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { session } = useAuth()
  const location = useLocation()

  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}
